// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"158":"f5c0ba51","224":"e724750d","963":"7a7e1d0e"}[chunkId] + ".css";
};